export default {
  init() {},
};
